// extracted by mini-css-extract-plugin
export default {"container":"PackageList_container__pYryy","switch":"PackageList_switch__p3JLm font-sm-regular"};